import { useState } from 'react';
import { Modal } from 'ui';
import { Steps } from './steps';

export type TelehealthRequestStep = 'notice' | 'personal-form' | 'telehealth-form';

type P = {
  isOpened: boolean;
  onClose: () => void;
};

const TelehealthRequestStepsModal = ({ isOpened, onClose }: P) => {
  const [step, setStep] = useState<TelehealthRequestStep>('notice');

  const handleClose = () => {
    setStep('notice');
    onClose();
  };

  const getModalTitle = () => {
    switch (step) {
      case 'notice':
        return 'Important notice';
      case 'personal-form':
        return 'Confirm your information';
      case 'telehealth-form':
        return 'Request Telehealth Visit';
    }
  };

  return (
    <Modal
      destroyOnHidden
      isOpened={isOpened}
      onCancel={() => {
        handleClose();
      }}
      title={getModalTitle()}
      width="medium"
    >
      <Modal.HugContent>
        <Steps onClose={handleClose} setStep={setStep} step={step} />
      </Modal.HugContent>
    </Modal>
  );
};

export default TelehealthRequestStepsModal;
